import template from "./user-profile-modal.html";
import "./user-profile-modal.less";

export function controller($logger, $uibModal, openIdService, $userProfile) {
	const ctrl = this;

	ctrl.signOut = signOut;
	ctrl.openChangePasswordModal = openChangePasswordModal;
	ctrl.$onInit = onInit;
	ctrl.openVersionInfo = openVersionInfo;
	ctrl.handleClose = handleClose;

	function handleClose() {
		ctrl.modalInstance.dismiss();
	}

	function onInit() {
		ctrl.isCollapsed = true;

		ctrl.user = $userProfile.getUser();
	}

	function openChangePasswordModal() {
		$uibModal.open({
			component: "change-password-modal",
			size: "slim"
		});
	}

	function signOut() {
		openIdService.getUserManager().signoutRedirect();
	}

	function openVersionInfo() {
		showBuildInformation();
	}

	function showBuildInformation() {
		$uibModal.open({
			component: "buildInformationModal",
			size: "lg"
		});
	}
}

export default angular
	.module("vesl.components.user-profile-modal", [])
	.component("userProfileModal", {
		template,
		controller,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
